module.exports = __webpack_public_path__ + "img/poker-h04.e7a2ce51.svg";